import { type ReactNode } from 'react'
import './MeetingTemplate.scss'

interface MeetingTemplatePresetIconWrapperProps {
  children: ReactNode
}

export const MeetingTemplatePresetIconWrapper: React.FC<MeetingTemplatePresetIconWrapperProps> = ({ children }) => {
  return <div className='meetingTemplatePresetIconWrapper'>{children}</div>
}
